import {EVENT_PREFIX} from '../../../helpers';

export default (
  {
    instanceKey,
    data
  }) => (Object.assign({
  type: `${EVENT_PREFIX}_UPDATE_PREVIOUS_FORM_DATA`
}, {instanceKey, data}));
